module.exports = __webpack_public_path__ + "static/media/logoTercoBlanco16x16.b22da98e.png";